import React from 'react'
import Link from 'next/link'
import classNames from 'classnames'

import classes from '../styles.module.scss'

interface NavItemProps {
  id?: string
  route: string
  text: string
  isActive: boolean
  testId?: string
  withUnderline?: boolean
}

export const NavItem: React.FC<NavItemProps> = ({
  id,
  route,
  text,
  isActive,
  testId,
  withUnderline = true
}) => {
  const target = route.startsWith('http') ? '_blank' : '_self'

  return (
    <Link
      id={id}
      href={route}
      target={target}
      data-testid={testId}
      className={classNames({
        [classes.item]: true,
        [classes.item__active]: isActive
      })}
    >
      <li>{text}</li>
      {withUnderline && <div className={classes.item__underline} />}
    </Link>
  )
}
